import { useEffect } from 'react';
import { ShipCanvas } from './ship/ShipCanvas.tsx';
import { Topbar } from './ui/Topbar.tsx';
import { StatusPanel } from './ui/StatusPanel.tsx';
import { LoginScreen } from './ui/LoginScreen.tsx';
import { useAppStore } from './state/store';

export function App() {
  const { accessToken, refreshAll, toast } = useAppStore();

  useEffect(() => {
    if (!accessToken) return;
    refreshAll();
    const interval = setInterval(refreshAll, 10_000);
    return () => clearInterval(interval);
  }, [accessToken, refreshAll]);

  if (!accessToken) {
    return (
      <div className="relative z-10 flex h-full w-full flex-col">
        <Topbar />
        <main className="flex min-h-0 flex-1">
          <LoginScreen />
        </main>
      </div>
    );
  }

  return (
    <div className="relative z-10 flex h-full w-full flex-col">
      <Topbar />
      <main className="flex min-h-0 flex-1">
        <div className="flex-1 relative">
          <ShipCanvas />
        </div>
        <StatusPanel />
      </main>
      {toast && (
        <div className="fixed bottom-4 right-4 z-50 rounded border border-neon-cyan/40 bg-hull-900/95 px-4 py-2 text-sm text-hull-100 shadow-lg backdrop-blur">
          {toast}
        </div>
      )}
    </div>
  );
}
